module.exports = __webpack_public_path__ + "0bc792d17f5ba951e8af1de36445392c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile2.png
// module id = 1880
// module chunks = 0